export function formatNumber(num) {
    if (typeof num !== "number") return "0";
    if (num < 1000) return num.toString();
    const units = ["", "k", "M", "B", "T"];
    const order = Math.floor(Math.log10(num) / 3);
    const unitname = units[order];
    const numShort = num / Math.pow(10, order * 3);
    return numShort % 1 === 0 ? numShort.toFixed(0) + unitname : numShort.toFixed(1) + unitname;
  }